module.exports = __webpack_public_path__ + "static/media/galerija_2019 (19).dbfe4b85.jpg";